import React, { useEffect } from 'react';
import Lenis from 'lenis';

const LENIS_OPTIONS = {
  duration: 1.2,
  smoothWheel: true,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
};

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis(LENIS_OPTIONS);
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
}
